import React from "react";
import { Box, TextField, Tooltip, Typography } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import { InfoOutlined } from "@material-ui/icons";
import { i18n } from "../../../translate/i18n";

/**
 * Datos del contacto simulado (0383 FS-2.11 / D6).
 *
 * No es cosmética: `fn_flowbuilder_process_variables` resuelve {{name}}, {{firstName}} y
 * {{number}} leyendo el contacto del ticket, así que estos campos alimentan también el
 * resultado de los nodos `condition`. Cambiarlos puede cambiar el camino del flujo.
 */
const SimContactForm = ({ contact, setContact, disabled }) => {
  const theme = useTheme();

  return (
    <Box display="flex" flexDirection="column" style={{ gap: 8 }}>
      <Box display="flex" alignItems="center" style={{ gap: 4 }}>
        <Typography variant="caption" style={{ fontWeight: 600 }}>
          {i18n.t("flowbuilders.simulator.contactTitle") || "Contacto simulado"}
        </Typography>
        <Tooltip
          title={
            i18n.t("flowbuilders.simulator.contactHint") ||
            "Alimenta las variables de nombre, primer nombre y número del contacto, y con ellas el resultado de los nodos de condición."
          }
        >
          <InfoOutlined
            style={{ fontSize: 14, color: theme.palette.text.secondary }}
          />
        </Tooltip>
      </Box>

      <Box display="flex" style={{ gap: 8 }}>
        <TextField
          size="small"
          variant="outlined"
          fullWidth
          disabled={disabled}
          label={i18n.t("flowbuilders.simulator.contactName") || "Nombre"}
          value={contact.name}
          onChange={(e) => setContact((prev) => ({ ...prev, name: e.target.value }))}
        />
        <TextField
          size="small"
          variant="outlined"
          fullWidth
          disabled={disabled}
          label={i18n.t("flowbuilders.simulator.contactNumber") || "Número"}
          value={contact.number}
          onChange={(e) => setContact((prev) => ({ ...prev, number: e.target.value }))}
        />
      </Box>
    </Box>
  );
};

export default SimContactForm;
